<template>
  <nav id="main-menu" class="menu inline">
    <router-link v-for="route in routes" :key="route.name" :to="{ name: route.name }" tag="li"><a><i :class="'icon icon-' + route.icon"></i> <span>{{ route.label|t }}</span></a></router-link>
  </nav>
</template>

<script>
  export default {
    name: 'MainMenu',
    props: {
      routes: {
        type: Array,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MainMenu.vue